export const getAdministradorApiUrl = (pathname: string) => process.env.REACT_APP_SC_ADMINISTRADOR_API_URL + pathname
export const getInfoIndividualOrientation = (pathname: string) => process.env.REACT_APP_SC_ADMINISTRADOR_API_URL + pathname
